/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Unsync_Delete_GoogleInputs */

const cs_tasks_unsync_delete_google = /** @type {(inputs: Tasks_Unsync_Delete_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento úkol je v Google Kalendáři. Smazat i událost v Google?
OK = smazat. Zrušit = nechat v Google a jen vypnout synchronizaci v CRM.`)
};

const en_tasks_unsync_delete_google = /** @type {(inputs: Tasks_Unsync_Delete_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This task is on Google Calendar. Delete the Google event too?
OK = delete it. Cancel = keep it in Google and only stop CRM sync.`)
};

/**
* | output |
* | --- |
* | "This task is on Google Calendar. Delete the Google event too? OK = delete it. Cancel = keep it in Google and only stop CRM sync." |
*
* @param {Tasks_Unsync_Delete_GoogleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_unsync_delete_google = /** @type {((inputs?: Tasks_Unsync_Delete_GoogleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Unsync_Delete_GoogleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_unsync_delete_google(inputs)
	return cs_tasks_unsync_delete_google(inputs)
});